'use client';

import { usePathname } from 'next/navigation';
import { Layout } from './Layout';

/**
 * ConditionalLayout 컴포넌트 Props 인터페이스
 * 
 * 조건부 레이아웃에 포함될 자식 요소들을 정의합니다.
 */
interface ConditionalLayoutProps {
  children: React.ReactNode;
}

/**
 * 조건부 레이아웃 컴포넌트
 * 
 * 현재 페이지 경로에 따라 적절한 레이아웃을 적용하는 컴포넌트입니다.
 * 관리자 페이지(`/admin`)인 경우 레이아웃 없이 렌더링하고,
 * 일반 페이지인 경우 기본 레이아웃을 적용합니다.
 * 
 * 주요 기능:
 * - 페이지 경로 기반 레이아웃 선택
 * - 관리자 페이지와 일반 페이지 구분
 * - 관리자 페이지는 헤더/푸터 없는 깔끔한 인터페이스
 * - 일반 페이지는 완전한 웹사이트 레이아웃
 * - Next.js App Router와 호환
 */
export function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname();

  // 관리자 페이지인지 확인
  const isAdminPage = pathname?.startsWith('/admin');

  // 관리자 페이지인 경우 레이아웃 없이 렌더링
  if (isAdminPage) {
    return <>{children}</>;
  }

  // 일반 페이지인 경우 기존 레이아웃 적용
  return <Layout>{children}</Layout>;
} 